import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';

import { IDataTableColumn } from '../../common/types/dataTable';
import DataTable from '../../common/components/DataTable';
import CardWrapper from '../../common/components/CardWrapper';
import FilterView from '../../common/components/FilterView';
import { useEffect, useState } from 'react';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';
import { getDashboardData } from '../dashboard/actions/dashboard';
import { useDispatch } from 'react-redux';

import {
  toggleColumnSettingsDashboard,
  updateColumnDefinition,
  updateColumnDefinitionConfigs,
} from '../dashboard/slices/dashboardSlice';
import { getColumnViews } from '../../common/actions/dataTable';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { AESEncrypt } from '../../../encrypt-util';
import moment from 'moment';
import { updateDashbaordName } from '../../common/slices/navbarTop';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import DashboardContainer from '../../../components/common/DashboardContainer';
import { updateDashbaordRefresh } from '../../common/components/DataTable/slices/DataTable';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';

const gridName = 'DOCUMENT_MST_DASHBOARD';
const view = "DOCUMENT_MASTER"

const DocumentManagementDashboard = () => {
  // Packages
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  // States
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const [currentPage, setCurrentPage] = useState<number>(1);

  const data = useSelector(
    (state: RootState) => state.dashboard.helpDocumentList
  );
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );
  const rbac = useSelector((state: RootState) => state.userProfile);

  const navigate = useNavigate();
  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const docManagmentGrids = useSelector(
    (state: RootState) => state.dataTable.docManagmentGrids
  );
  const showColumnSettings = useSelector(
    (state: RootState) => state.dashboard.showColumnSettings
  );
  const onHideColumnSettings = () => {
    dispatch(toggleColumnSettingsDashboard(false));
  };
  const filterStateLocal = filterState?.['docManagement'] || {};

  const documentManagementChild = (() => {
    if(location.pathname.includes("uploadDocument") || !rbac.rbacDetails.enableHelpDocumentAddition) return <></>;
    return <>
      <div className='d-flex '>
        <Button
          variant="falcon-primary"
          style={{
            color: "#f5803e"
          }}
          size="sm"
          onClick={() => {
            navigate(`/documentManagment/uploadDocument`);
          } }
        >
          <div className="d-flex">
            <FontAwesomeIcon icon={faCloudArrowUp} className="me-2 mt-1 " />
            <span style={{
              color: "#3f8cff"
            }}>Upload</span>
          </div>
        </Button>
      </div>
    </>;
  })();

  const findFieldsByConfigId = (selectedConfigId: any, configGroup: any) => {
    const matchedConfig = configGroup?.find(
      (config: any) => config?.userGridId == selectedConfigId
    );
    if (matchedConfig && matchedConfig?.columnConfig) {
      const fields = matchedConfig?.columnConfig
        .filter((column: any) => column?.visible === 'true')
        .map((column: any) => column?.accessor);
      return { fields };
    } else {
      return { fields: [] };
    }
  };
  const configGroup = docManagmentGrids?.[0]?.configGroupGrid;
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );

  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const dataCountry = linerDataCountry ?? profileDetails.partnerCountry ?? "";
  
  const generateColumnConfig = useGenerateColumnConfig()

  const loadDocMstData = (filterUpdated: boolean) => {
    const SelectedViewFields = findFieldsByConfigId(
      selectedConfigId?.docManagement,
      configGroup
    );
    if (filterUpdated) setCurrentPage(1);
    const sort = (queryString.parse(location.search)?.sort as string)
      ?.split?.(',')
      ?.join?.(' ');
    if (filterStateLocal && Object.keys(filterStateLocal)?.length > 0) {
      const filterApiState: any = {};

      const filterKeys = Object.keys(filterStateLocal);

      for (let k of filterKeys) {
        if (filterStateLocal?.[k]?.from) {
          filterApiState[k] = [
            filterStateLocal?.[k]?.from || '',
            filterStateLocal?.[k]?.to || '',
          ].filter((i) => i);
        } else if (filterStateLocal?.[k]?.from !== undefined) {
          filterApiState[k] = undefined;
        } else {
          filterApiState[k] = filterStateLocal?.[k]
            ? typeof filterStateLocal?.[k] === 'string'
              ? [filterStateLocal?.[k]]
              : filterStateLocal?.[k]
            : undefined;
        }
      }
      if (Object.keys(filterApiState)?.length > 0) {
        const finalFilterApiState: any = {};

        for (let i of Object.keys(filterApiState)) {
          if (filterApiState[i]) {
            finalFilterApiState[i] = filterApiState[i];
          }
        }
        if (searchInputValue.trim() !== "") {
          finalFilterApiState[selectedTopSearchFilter.id] = typeof searchInputValue === 'string' ? [searchInputValue] : searchInputValue;
        }
        dispatch(
          getDashboardData({
            gridName: view,
            payload: {
              fields: SelectedViewFields?.fields || [],
              filters: !selectedTopSearchFilter?.where ||
                selectedTopSearchFilter?.where == ''
                ? finalFilterApiState
                : {},
              size: 20,
              sorts: sort ? [sort] : ['app_id desc'],
              page: filterUpdated ? 1 : currentPage,
            },

            dataCountry: dataCountry,
            partnerId:
              profileDetails.partnerType === 'customer'
                ? profileDetails.partnerId
                : null,
            where: docManagmentGrids?.[0]?.whereClause
              ? AESEncrypt(docManagmentGrids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== '' &&
                searchInputValue.trim() !== ""
                ? {
                  searchParameter: searchInputValue,
                  searchWhere: selectedTopSearchFilter?.where,
                }
                : {},
          })
        );
      }
    }
  };
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const sideWidth =
    Object.entries({
      [`${APP_PATH_PREFIX}/documentManagment`]: 0,
    }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9;

  useEffect(() => {
    if (dataCountry && linerId) {
      dispatch(
        getColumnViews({ gridName: gridName, country: dataCountry, linerId: linerId, language: language || localStorage.getItem('selectedLanguage') || 'EN' })
      );
      loadDocMstData(true);
    }
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    if (refresh) loadDocMstData(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);


  useEffect(() => {
    loadDocMstData(false);
  }, [currentPage]);

  useEffect(() => {
    const emailTemplateRefuncdColumn = docManagmentGrids?.[0]?.columnConfigGrid || '';

    // const configs = generateColumnConfig(emailRefuncdColumn);
    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(emailTemplateRefuncdColumn))
      );
      setColumns(configs.columns);
      setConfigs(configs);
      dispatch(updateColumnDefinitionConfigs(configs));
      dispatch(updateColumnDefinition(columns));
    } catch (e: any) {
      console.error('Column Error: ', e);
    }
  }, [docManagmentGrids]);

  useEffect(() => {
    dispatch(updateDashbaordName(gridName));
  }, [])

  useEffect(() => {
    loadDocMstData(true);
  }, [filterState, location.search, linerId, searchInputValue, language]);

  return (
    <DashboardContainer
      sideWidth={sideWidth}
    >
      <FilterView
        showExport={true}
        data={data}
        showColumnSettings={true}
        uniqueFilterKey={gridName}
        toggleColumnSettings={toggleColumnSettingsDashboard}
        configViews={
          docManagmentGrids?.find?.((g) => g?.gridName === gridName)
            ?.configGroup || []
        }
        showRightDiv={!!matchPath(location.pathname, '/documentManagment')}
        child={documentManagementChild}
        dashboardName={gridName}
        gridDef={docManagmentGrids}
      />
      {columns.length > 0 && (
        <DataTable
          columns={columns}
          data={data?.result || null}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || '100')}
          hasNext={data?.hasNext}
          currentPage={currentPage}
          showColumnSettings={showColumnSettings}
          onHide={onHideColumnSettings}
          onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
          selection={undefined}
          sortable={undefined}
          perPage={20}
          searchable={false}
          showExport={undefined}
          showColumnFilter={undefined}
          uniqueFilterKey={'docManagement'}
          defaultHiddenCols={configs?.defaultHiddenCols || []}
          staticHiddenCols={configs?.staticHiddenCols || []}
          gridName={gridName}
          configGroup={
            //  grids?.find?.((g) => g?.gridId === 2)?.configGroup || []
            docManagmentGrids?.find?.((g) => g?.gridName === gridName)
              ?.configGroup || []
          }
          gridId={docManagmentGrids?.[0]?.gridId || 0}
          customSort
        />
      )}
    </DashboardContainer>
  );
};

export default DocumentManagementDashboard;
